
export default function prm(params) {
  return {
    page: 1,
    limit: 25,
    ...params,
  }
}
